import styled from 'styled-components';
import { ReactElement } from 'react';
import { DicoLogo } from '../Logos';
import BackgroundImagePng from '../../assets/images/background_image.png';
import { useLocation } from 'react-router-dom';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';

type WrapperProps = {
    merchant: boolean;
};

const Wrapper = styled.header`
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    right: 0;
    width: 100vw;
    z-index: 1;
`;

const ColorStrip = styled.div<WrapperProps>`
    width: 100%;
    height: 80px;
    background: ${(props) =>
        props.merchant ? '#2A2E43' : 'linear-gradient(116deg, #ed1e79, #9e005d);'};
    background-position: 50% 50%;
    background-size: cover;
    position: relative;

    @media screen and (max-width: 768px) {
        height: 60px;
    }

    @media screen and (max-width: 480px) {
        height: 50px;
    }
`;

const HeaderContent = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media screen and (max-width: 768px) {
        padding: 0 20px;
    }

    @media screen and (max-width: 480px) {
        padding: 0 15px;
    }
`;

const LogoContainer = styled.div`
    display: flex;
    align-items: center;
    height: 100%;

    svg {
        height: calc(100% - 20px);
        width: auto;
        max-height: 60px;
        min-height: 30px;
    }

    @media screen and (max-width: 768px) {
        svg {
            height: calc(100% - 16px);
            max-height: 44px;
            min-height: 28px;
        }
    }

    @media screen and (max-width: 480px) {
        svg {
            height: calc(100% - 12px);
            max-height: 38px;
            min-height: 24px;
        }
    }
`;

const LanguageSwitcherContainer = styled.div`
    display: flex;
    align-items: center;
    z-index: 10;
`;

const BackgroundImageContainer = styled.div`
    display: block;
    width: 100%;
    height: 300px;
    position: relative;

    @media screen and (max-width: 768px) {
        height: 200px;
    }

    @media screen and (max-width: 480px) {
        height: 150px;
    }
`;

const BackgroundImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
`;

const Header = (): ReactElement => {
    const { pathname } = useLocation();
    const merchant = pathname.includes('attachments');

    return (
        <Wrapper>
            <ColorStrip merchant={merchant}>
                <HeaderContent>
                    <LogoContainer>
                        <DicoLogo />
                    </LogoContainer>
                    <LanguageSwitcherContainer>
                        <LanguageSwitcher />
                    </LanguageSwitcherContainer>
                </HeaderContent>
            </ColorStrip>
            <BackgroundImageContainer>
                <picture>
                    <source srcSet={BackgroundImagePng} type="image/png" />
                    <BackgroundImage src={BackgroundImagePng} alt="Background" />
                </picture>
            </BackgroundImageContainer>
        </Wrapper>
    );
};

export default Header;
